export class SearchLogsHistogramResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "data",
            "baseName": "data",
            "type": "Array<LogsHistogramDataPoint>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return SearchLogsHistogramResponse.attributeTypeMap;
    }
    constructor() {
    }
}
